// Versioning: bumped with each release. Reported in heartbeat and enrollment.
// Falls back to runtime env (PWA_VERSION) if defined; otherwise hardcoded.
import { config } from './config.js';

export const PWA_VERSION = config.pwaVersion || '0.1.0';
